import React, { Component } from 'react';

import classnames from 'classnames';

export default class Loading extends Component {
	render() {
		let s = 'fa-2x';

		if (this.props.size == 3) {
			s = 'fa-3x';
		}

		let cl = classnames('fa fa-cog fa-spin', s, this.props.className);

		return (
			<div className='text-center' style={this.props.style}>
				<div className={cl}></div>
			</div>
		);
	}
}
